// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var MagicTransitLogo = function MagicTransitLogo(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.546 3.627L10.332.5H4.74l-.053.053-3.445 3.1L.5 9.193l.027.053 2.385 3.763 4.637 2.464.08.027 5.221-2.359 2.65-4.028zm-1.723 8.905l-.689-4.214a2.039 2.039 0 00.954-.61L15.1 9.087zM7.682 15.1l-1.511-2.224c.053-.053.08-.106.133-.159l5.751.4zm-6.44-5.377L4.9 12.161a1.1 1.1 0 00-.026.291l-1.774.239zM9.7.845L4.8 3.839a.989.989 0 00-.53-.318L4.952.845zm.292 5.141L5.111 4.793v-.132a1.211 1.211 0 00-.132-.53l5.194-3.18L11.1 4.9a1.688 1.688 0 00-1.112 1.086zm-4.987-.875L9.882 6.3a.882.882 0 00-.027.265 1.648 1.648 0 00.424 1.139l-4.108 4.112a.725.725 0 00-.5-.212l-1.408-5.83a1.223 1.223 0 00.742-.663zm1.325 7l4.188-4.135a1.847 1.847 0 001.166.425h.132l.716 4.425-6.149-.45a.476.476 0 00-.053-.265zm6.47-6.947a1.9 1.9 0 00-1.113-.4.915.915 0 00-.265.026l-.875-3.71 3.575 2.68zm-8.878-1.7a1.23 1.23 0 00-1.037.636l-1.192-.45 2.782-2.514zm-.586 2.177a1.164 1.164 0 00.583.186l1.431 5.83a.639.639 0 00-.239.159l-.053.053L.924 9.113zm1.669 7.129a.207.207 0 00.106.106.807.807 0 00.8.186l1.219 1.8-3.556-1.88zm8.269-5.3a1.8 1.8 0 00-.212-2.07l1.219-1.3.819 4.616zm-11.74-3.5l1.272.477c0 .053-.027.132-.027.212a1.152 1.152 0 00.292.768L.951 8.5z"
    }))
  );
};

export default MagicTransitLogo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/MagicTransitLogo.js
// module id = 1028
// module chunks = 0